import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { RequestApprovalDto } from '../models/requestapproval-dto';
import { ManPowerApprovalDto } from '../models/manpowerapproval-dto';

@Injectable({
  providedIn: 'root'
})
export class ManpowerapprovalService {

  constructor(private httpClient: HttpClient) { }
  getRequestApprovals(requestId:number): Observable<ApiResponseObject<ManPowerApprovalDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ManPowerApprovalDto[]>>(`${environment.apiUrl}/RequestApprovals/GetByManpowerRequestId${requestId}`);
  }
}
